import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/header";
import "./Adduser.css";

const AddUser = () => {
    const [formData, setFormData] = useState({
        full_name: "",
        employee_id: "",
        phone: "",
        user_email_id: "",
        password: "",
        role: "",
        dob: "",
        gender: "",
        address: "",
        city: "",
        state: "",
        country: "",
        zip: "",
        emergency_contact: "",
        job_title: "",
        department: "",
        doj: "",
        status: "Active",
    });

    const [roles, setRoles] = useState([]);
    const [privileges, setPrivileges] = useState([]);
    const [selectedPrivileges, setSelectedPrivileges] = useState([]);
    const [loginError, setLoginError] = useState("");

    useEffect(() => {
        // Fetch roles
        fetch("/api/roles")
            .then(res => res.json())
            .then(data => setRoles(data))
            .catch(err => console.error(err));

        // Fetch privileges
        fetch("/api/privileges")
            .then(res => res.json())
            .then(data => setPrivileges(data))
            .catch(err => console.error(err));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handlePrivilegeToggle = (id) => {
        setSelectedPrivileges(prev =>
            prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]
        );
    };

    const handleSaveAll = async () => {
        // Validate required fields
        for (let key in formData) {
            if (!formData[key]?.toString().trim()) {
                setLoginError(`Please fill ${key.replace("_", " ")}`);
                return;
            }
        }
        setLoginError("");

        // Save logic goes here
        alert("User saved / privileges assigned successfully!");
    };

    return (
        <div>
        <Header/>
        <div className="add-user-container">
            <div className="section-card">
                <div className="section-header">Add User</div>
                {loginError && <p className="error-msg">{loginError}</p>}
                <form className="form-grid">
                    {/* ===== 3 fields per row ===== */}
                    <div className="form-field"><label>Full Name *</label><input type="text" name="full_name" value={formData.full_name} onChange={handleChange} required /></div>
                    <div className="form-field"><label>Employee ID *</label><input type="text" name="employee_id" value={formData.employee_id} onChange={handleChange} required /></div>
                    <div className="form-field"><label>Phone Number *</label><input type="text" name="phone" value={formData.phone} onChange={handleChange} required /></div>
                    <div className="form-field"><label>Email *</label><input type="email" name="user_email_id" value={formData.user_email_id} onChange={handleChange} required /></div>
                    <div className="form-field"><label>Password *</label><input type="password" name="password" value={formData.password} onChange={handleChange} required /></div>
                    <div className="form-field">
                        <label>User Role *</label>
                        <select name="role" value={formData.role} onChange={handleChange} required>
                            <option value="">Select Role</option>
                            {roles.map(r => <option key={r.id} value={r.role_name}>{r.role_name}</option>)}
                        </select>
                    </div>
                    <div className="form-field"><label>Date of Birth</label><input type="date" name="dob" value={formData.dob} onChange={handleChange} /></div>
                    <div className="form-field">
                        <label>Gender</label>
                        <select name="gender" value={formData.gender} onChange={handleChange}>
                            <option value="">Select</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                    </div>
                    <div className="form-field"><label>Address</label><input type="text" name="address" value={formData.address} onChange={handleChange} /></div>
                    <div className="form-field"><label>City</label><input type="text" name="city" value={formData.city} onChange={handleChange} /></div>
                    <div className="form-field"><label>State</label><input type="text" name="state" value={formData.state} onChange={handleChange} /></div>
                    <div className="form-field"><label>Country</label><input type="text" name="country" value={formData.country} onChange={handleChange} /></div>
                    <div className="form-field"><label>ZIP</label><input type="text" name="zip" value={formData.zip} onChange={handleChange} /></div>
                    <div className="form-field"><label>Emergency Contact</label><input type="text" name="emergency_contact" value={formData.emergency_contact} onChange={handleChange} /></div>
                    <div className="form-field"><label>Job Title / Designation</label><input type="text" name="job_title" value={formData.job_title} onChange={handleChange} /></div>
                    <div className="form-field"><label>Department</label><input type="text" name="department" value={formData.department} onChange={handleChange} /></div>
                    <div className="form-field"><label>Date of Joining</label><input type="date" name="doj" value={formData.doj} onChange={handleChange} /></div>
                    <div className="form-field">
                        <label>Status</label>
                        <select name="status" value={formData.status} onChange={handleChange}>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select>
                    </div>
                </form>

                {/* ===== Assign Privileges ===== */}
                <div className="section-card" style={{ marginTop: "20px" }}>
                    <div className="section-header">Assign Privileges</div>
                    <div className="privileges-grid">
                        {privileges.map(p => (
                            <div key={p.id} className="privilege-box">
                                <label className="privilege-label">
                                    <input
                                        type="checkbox"
                                        checked={selectedPrivileges.includes(p.id)}
                                        onChange={() => handlePrivilegeToggle(p.id)}
                                    />
                                    {p.privilege_name}
                                </label>
                                {p.description && <p className="privilege-desc">{p.description}</p>}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Save Button */}
                <div className="form-actions" style={{ marginTop: "20px" }}>
                    <button type="button" onClick={handleSaveAll}>Save User & Privileges</button>
                </div>
            </div>
        </div>
        </div>
    );
};

export default AddUser;
